import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

import {
  SET_GAME_COUPON_POPUP_SHOW_STATUS,
  UPDATE_GAME_ENABLE_COUPON_LIST,
  UPDATE_GAME_DISABLE_COUPON_LIST,
  UPDATE_GAME_EXPIRE_COUPON_LIST,
  LOAD_GAME_COUPON_LIST,
  UPDATE_GAME_ACTIVE_COUPON_ID,
  LOAD_PAYTYPE_COUPON_LIST,
  UPDATE_PAYTYPE_ACTIVE_COUPON_ID,
  SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS,
  SET_VIP_COUPON_SHOW_STATUS,
  SET_BIRTH_COUPON_SHOW_STATUS,
  LOAD_VIP_COUPON_INFO
} from '@store/officialTopupNew/coupon';
import {
  popupType,
  showPopup,
  clickButton,
  locationType
} from '@plugins/biPoint/_configWebstoreV35';
export default {
  data() {
    return {
      isShowCouponConfirmPopup: false,
      hasConfirmCoupon: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isShowGameCouponEntry: state => state.coupon.isShowGameCouponEntry,
      isShowGameCouponPopup: state => state.coupon.isShowGameCouponPopup,
      isShowGameItemUseBtn: state => state.coupon.isShowGameItemUseBtn,
      gameCouponEnableList: state => state.coupon.gameCouponEnableList,
      gameCouponDisableList: state => state.coupon.gameCouponDisableList,
      gameCouponExpireList: state => state.coupon.gameCouponExpireList,
      gameActiveCouponId: state => state.coupon.gameActiveCouponId,
      isShowVipCouponPopup: state => state.coupon.isShowVipCouponPopup,
      isShowBirthCouponPopup: state => state.coupon.isShowBirthCouponPopup,
      vipLevel: state => state.coupon.vipLevel,
      vipNextLevelPoint: state => state.coupon.vipNextLevelPoint,
      vipSumPoint: state => state.coupon.vipSumPoint,
      vipCouponList: state => state.coupon.vipCouponList,
      birthCouponList: state => state.coupon.birthCouponList,
      picList: state => state.page.picList,

      isShowPaytypePopupCoupon: state => state.coupon.isShowPaytypePopupCoupon,
      paytypeEnableCouponList: state => state.coupon.paytypeEnableCouponList,
      paytypeDisableCouponList: state => state.coupon.paytypeDisableCouponList,
      paytypeExpireCouponList: state => state.coupon.paytypeExpireCouponList,
      paytypeActiveCouponId: state => state.coupon.paytypeActiveCouponId
    }),
    ...mapGetters([
      'activeGameCouponProductList',
      'activePaytypeCouponInfo',
      'activePaytypeCouponFullReductType',
      'activePaytypeCouponDiscountType',
      'activePaytypeCouponReductPrice',
      'activePaytypeCouponReductionName',
      'activePaytypeCouponDiscountName'
    ]),
    submitCouponInfoName() {
      if (!this.paytypeActiveCouponId) {
        return '';
      }

      if (this.activePaytypeCouponFullReductType) {
        return this.activePaytypeCouponReductionName;
      }

      return this.activePaytypeCouponDiscountName;
    },
    isCouponActive() {
      return coupon => {
        if (this.popupType == 'paytype') {
          return coupon.COUPON_ID == this.paytypeActiveCouponId;
        }
        if (this.popupType == 'game') {
          return coupon.COUPON_ID == this.gameActiveCouponId;
        }
      };
    },
    // 优惠券按钮相关的通用计算属性
    couponIconStyle() {
      return `background-image: url(${this.picList.couponIcon});`;
    },
    showRedDot() {
      return this.gameCouponEnableList?.length > 0;
    }
  },
  watch: {
    activePaytypeCouponInfo() {
      this.hasConfirmCoupon = false;
    }
  },
  methods: {
    ...mapMutations({
      setGameCouponPopupShowStatus: SET_GAME_COUPON_POPUP_SHOW_STATUS,
      updateGameEnableCouponList: UPDATE_GAME_ENABLE_COUPON_LIST,
      updateGameDisableCouponList: UPDATE_GAME_DISABLE_COUPON_LIST,
      updateGameExpireCouponList: UPDATE_GAME_EXPIRE_COUPON_LIST,
      updateGameActiveCouponId: UPDATE_GAME_ACTIVE_COUPON_ID,
      setPaytypeCouponPopupShowStatus: SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS,
      updatePaytypeActiveCouponId: UPDATE_PAYTYPE_ACTIVE_COUPON_ID,
      setVipCouponShowStatus: SET_VIP_COUPON_SHOW_STATUS,
      setBirthCouponShowStatus: SET_BIRTH_COUPON_SHOW_STATUS
    }),
    ...mapActions({
      loadGameCouponList: LOAD_GAME_COUPON_LIST,
      loadPaytypeCouponList: LOAD_PAYTYPE_COUPON_LIST,
      loadVipCouponInfo: LOAD_VIP_COUPON_INFO
    }),
    hideGameCouponPopup() {
      this.setGameCouponPopupShowStatus(false);
    },
    showGameCouponPopup() {
      this.setGameCouponPopupShowStatus(true);
      showPopup(popupType.myCouponPopup);
    },
    hideVipCouponPopup() {
      this.setVipCouponShowStatus(false);
    },
    hideBirthCouponPopup() {
      this.setBirthCouponShowStatus(false);
    },
    resetGameActiveCoupon() {
      this.updateGameActiveCouponId('');
    },
    checkInGameActiveCoupon(productId, cpProductId) {
      let length = this.activeGameCouponProductList.length;
      for (let i = 0; i < length; i++) {
        if (
          productId == this.activeGameCouponProductList[i].PRODUCT_ID &&
          cpProductId == this.activeGameCouponProductList[i].CP_PRODUCT_ID
        ) {
          return true;
        }
      }
      return false;
    },
    hidePaytypeCouponPopup() {
      this.setPaytypeCouponPopupShowStatus(false);
    },
    showPaytypeCouponPopup() {
      this.setPaytypeCouponPopupShowStatus(true);
      showPopup(popupType.paytypeCouponPopup);
    },
    togglePaytypeCouponPopup() {
      if (this.isShowPaytypePopupCoupon) {
        this.hidePaytypeCouponPopup();
      } else {
        this.showPaytypeCouponPopup();
      }
    },
    showVipCouponPopup() {
      this.setVipCouponShowStatus(true);
      showPopup(popupType.vipCouponPopup);
    },
    resetPaytypeActiveCoupon() {
      this.updatePaytypeActiveCouponId('');
    },
    async changePaytypeCouponList(param) {
      this.resetPaytypeActiveCoupon();
      await this.loadPaytypeCouponList(param);
      return Promise.resolve(true);
    },
    refreshGameCoupon() {
      this.loadGameCouponList();
      this.showGameCouponPopup();
    },
    // 优惠券按钮点击处理函数
    handleCouponButtonClick() {
      clickButton({
        btnName: 'coupon',
        locationKey: this.$route.meta.pageName
      });
      this.refreshGameCoupon();
    }
  }
};
